import { exampleData } from "./feature-page";

export const analysisData = exampleData;
